import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const AccountingPage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  let menu = [{ auth: "Jurnal", name: "Jurnal Umum", path: "/accounting/jurnal" }];
  let Report = [
    {
      auth: "Monitoring_Jurnal",
      name: "Monitoring Jurnal",
      path: "/accounting/Monitoring/jurnal",
    },
    {
      auth: "Account_Payable",
      name: "Account Payable",
      path: "/finance/account-payable",
    },
    { auth: "Jurnal", name: "Jurnal", path: "/finance/report/Journal" },
    {
      auth: "Buku_Besar",
      name: "Buku Besar",
      path: "/finance/report/buku-besar",
    },
    {
      auth: "Trial_Balance",
      name: "Trial Balance",
      path: "/finance/report/trial-balance",
    },
    { auth: "Neraca", name: "Neraca", path: "/accounting/report/neraca" },
    {
      auth: "Laba_Rugi",
      name: "Laba Rugi",
      path: "/accounting/report/laba-rugi",
    },
    { auth: "Closing", name: "Closing", path: "/accounting/Closing" },
    {
      auth: "MonitoringInvoiceQuatation",
      name: "Monitoring Invoice Quatation",
      path: "/finance/report/monitoring-invoice-quatation",
    },
  ];
  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase()),
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase()),
    );
    setListReport(filtered);
  };
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Transaction"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountingPage;
